import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from '../data/translations.json';

const TranslationContext = createContext();

export function TranslationProvider({ children }) {
  // Try to load language from localStorage
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('lang');
    if (saved === 'es' || saved === 'en') return saved;
    
    // Auto-detect browser language if no manual override exists
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang && browserLang.toLowerCase().startsWith('es')) {
      return 'es';
    }
    return 'en';
  });

  useEffect(() => {
    localStorage.setItem('lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    return translations[lang]?.[key] || key;
  };

  return (
    <TranslationContext.Provider value={{ t, lang, setLang }}>
      {children}
    </TranslationContext.Provider>
  );
}

export function useTranslation() {
  return useContext(TranslationContext);
}